// تفاعلات واجهة صفحة الدخول: تبديل اللغة الفوري، الوضع الداكن، التوهج، Caps Lock، العدّاد
(function () {
	const root = document.documentElement;
	const RTL = ["ar", "fa", "he", "ur"];
	const LANG_COOKIE = "preferred_language";
	const THEME_KEY = "theme_login_mode";
	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	const t = (key, ...args) => (window.login && login.t ? login.t(key, ...args) : key);
	const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

	// ربط نموذج التسجيل القادم من Frappe (signup_form_template) بالقاموس
	function annotateSignupForm() {
		const form = document.querySelector(".form-signup");
		if (!form) return;

		const map = [
			["#signup_fullname", "full_name_placeholder", "full_name"],
			["#signup_email", "email_placeholder", "email"],
		];
		map.forEach(([sel, placeholderKey, labelKey]) => {
			const input = form.querySelector(sel);
			if (!input) return;
			input.setAttribute("data-i18n-placeholder", placeholderKey);
			input.setAttribute("dir", "auto");
			const label = form.querySelector(`label[for="${input.id}"]`);
			if (label) {
				label.classList.remove("sr-only");
				label.setAttribute("data-i18n", labelKey);
			}
		});

		const btn = form.querySelector(".btn-signup");
		if (btn && !btn.querySelector(".btn-label")) {
			btn.classList.add("ml-btn");
			btn.innerHTML =
				'<span class="btn-label" data-i18n="signup"></span><span class="ml-spinner" aria-hidden="true"></span>';
		}

		const back = form.querySelector('.sign-up-message a[href="#login"]');
		if (back) back.setAttribute("data-i18n", "have_account");
	}

	function applyI18n(scope = document) {
		$$("[data-i18n]", scope).forEach((el) => {
			const arg = el.getAttribute("data-i18n-arg");
			el.textContent = arg !== null ? t(el.dataset.i18n, arg) : t(el.dataset.i18n);
		});
		$$("[data-i18n-placeholder]", scope).forEach((el) => {
			el.setAttribute("placeholder", t(el.dataset.i18nPlaceholder));
		});
		$$("[data-i18n-aria]", scope).forEach((el) => {
			el.setAttribute("aria-label", t(el.dataset.i18nAria));
		});
		$$("[data-i18n-title]", scope).forEach((el) => {
			el.setAttribute("title", t(el.dataset.i18nTitle));
		});
		$$("[data-i18n-compose]", scope).forEach((el) => {
			el.textContent = el.dataset.i18nCompose
				.split(",")
				.map((k) => t(k))
				.join(` ${t("or_word")} `);
		});
		$$(".indicator[data-i18n]", scope).forEach((el) => {
			el.setAttribute("data-text", t(el.dataset.i18n));
		});
		// روابط التواصل: نص رسالة واتساب وموضوع/نص البريد بلغة الواجهة الحالية
		$$("[data-wa]", scope).forEach((el) => {
			el.href = `https://wa.me/${el.dataset.wa}?text=${encodeURIComponent(t("wa_message"))}`;
		});
		$$("[data-mailto]", scope).forEach((el) => {
			const subject = encodeURIComponent(t("mail_subject"));
			const body = encodeURIComponent(t("mail_body"));
			el.href = `mailto:${el.dataset.mailto}?subject=${subject}&body=${body}`;
		});
		document.title = t("page_title");
	}

	function setLang(lang) {
		root.lang = lang;
		root.dir = RTL.includes(lang) ? "rtl" : "ltr";
		if (window.frappe && frappe.boot) frappe.boot.lang = lang;
		// Frappe يقرأ هذا الـ cookie لطلبات الضيف، فتصل رسائل الخادم بنفس اللغة
		document.cookie = `${LANG_COOKIE}=${lang}; path=/; max-age=31536000; SameSite=Lax`;
		applyI18n();
	}

	function toggleLang() {
		const next = root.lang === "ar" ? "en" : "ar";
		if (reduceMotion) return setLang(next);

		document.body.classList.add("ml-switching");
		setTimeout(() => {
			setLang(next);
			requestAnimationFrame(() => document.body.classList.remove("ml-switching"));
		}, 220);
	}

	function isDark() {
		const forced = root.getAttribute("data-theme");
		if (forced) return forced === "dark";
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	}

	function toggleTheme() {
		const next = isDark() ? "light" : "dark";
		root.setAttribute("data-theme", next);
		try {
			localStorage.setItem(THEME_KEY, next);
		} catch (e) {
			// التخزين غير متاح (وضع التصفح الخاص مثلاً)
		}
	}

	function bindCardGlow() {
		const card = document.getElementById("ml-card");
		if (!card || reduceMotion) return;
		card.addEventListener("pointermove", (e) => {
			const r = card.getBoundingClientRect();
			card.style.setProperty("--mx", `${e.clientX - r.left}px`);
			card.style.setProperty("--my", `${e.clientY - r.top}px`);
		});
	}

	function bindCapsLock() {
		const input = document.getElementById("login_password");
		const warn = document.querySelector(".ml-caps");
		if (!input || !warn) return;
		const check = (e) => {
			if (e.getModifierState) warn.hidden = !e.getModifierState("CapsLock");
		};
		input.addEventListener("keydown", check);
		input.addEventListener("keyup", check);
		input.addEventListener("blur", () => (warn.hidden = true));
	}

	function bindPasswordToggleKeys() {
		$$(".toggle-password").forEach((el) => {
			el.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					el.click();
				}
			});
		});
	}

	function copyText(text) {
		if (navigator.clipboard && window.isSecureContext)
			return navigator.clipboard.writeText(text);
		// Clipboard API غير متاحة على المواقع عبر http فنستخدم الطريقة القديمة
		const ta = document.createElement("textarea");
		ta.value = text;
		ta.setAttribute("readonly", "");
		ta.style.cssText = "position:fixed;opacity:0;pointer-events:none";
		document.body.appendChild(ta);
		ta.select();
		const ok = document.execCommand("copy");
		ta.remove();
		return ok ? Promise.resolve() : Promise.reject();
	}

	// نسخ البريد مفيد لمن لا يملك برنامج بريد مرتبطاً بروابط mailto
	function bindCopy() {
		$$("[data-copy]").forEach((btn) => {
			let timer;
			btn.addEventListener("click", () => {
				copyText(btn.dataset.copy)
					.then(() => {
						btn.classList.add("is-copied");
						clearTimeout(timer);
						timer = setTimeout(() => btn.classList.remove("is-copied"), 1600);
					})
					.catch(() => {});
			});
		});
	}

	function countUp() {
		$$("[data-count]").forEach((el) => {
			const target = parseInt(el.dataset.count, 10) || 0;
			if (reduceMotion) return;
			const start = performance.now();
			const duration = 1800;
			const step = (now) => {
				const p = Math.min((now - start) / duration, 1);
				const eased = 1 - Math.pow(1 - p, 3);
				el.textContent = Math.round(target * eased).toLocaleString("en-US");
				if (p < 1) requestAnimationFrame(step);
			};
			el.textContent = "0";
			setTimeout(() => requestAnimationFrame(step), 700);
		});
	}

	function init() {
		annotateSignupForm();
		applyI18n();

		document.getElementById("ml-lang-btn")?.addEventListener("click", toggleLang);
		document.getElementById("ml-theme-btn")?.addEventListener("click", toggleTheme);

		bindCardGlow();
		bindCapsLock();
		bindPasswordToggleKeys();
		bindCopy();
		countUp();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
